const CUSTOM_PROTOCOL_WORKSPACE_PATTERN = /^[a-z][a-z0-9+.-]*:\/\/@/i

export function getAppPathFromUrl(url: URL, href: string = url.href): string {
  const isWebLikeProtocol =
    url.protocol === 'http:'
    || url.protocol === 'https:'
    || url.protocol === 'capacitor:'
  const workspacePrefix = !isWebLikeProtocol && CUSTOM_PROTOCOL_WORKSPACE_PATTERN.test(href) ? '@' : ''
  const hostPrefix = !isWebLikeProtocol && url.hostname ? `/${workspacePrefix}${url.hostname}` : ''
  const pathname = url.pathname || ''
  const path = `${hostPrefix}${pathname}` || '/'
  return path + url.search + url.hash
}
